// extracted by mini-css-extract-plugin
module.exports = {"container":"Section_container__2AruD","actions":"Section_actions__1ROiu","count":"Section_count__1PVb5","name":"Section_name__qN3Sq"};